import React from "react";
import { cn } from "../../lib/utils";

const toneClasses = {
  default: "text-[#E2B05E]",
  info: "text-[#3AB8D6]",
  success: "text-emerald-400",
  warning: "text-amber-400",
  danger: "text-red-400",
  muted: "text-[#9CA3AF]",
};

export function MetricCard({
  label,
  value,
  description,
  icon: Icon,
  tone = "default",
  className,
  compact = false,
}) {
  return (
    <div className={cn("valhalla-card", compact ? "p-3" : "p-4", className)}>
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="truncate text-xs uppercase tracking-wide text-[#9CA3AF] sm:text-sm sm:normal-case sm:tracking-normal">
            {label}
          </p>
          <p
            className={cn(
              "mt-1 break-words font-['Outfit'] font-bold",
              compact ? "text-xl" : "text-xl sm:text-2xl",
              toneClasses[tone] || toneClasses.default,
            )}
          >
            {value}
          </p>
          {description ? (
            <p className="mt-1 text-xs text-[#9CA3AF]">{description}</p>
          ) : null}
        </div>
        {Icon ? (
          <div
            className={cn(
              "flex shrink-0 items-center justify-center rounded-lg bg-[#0B0E14]/60",
              compact ? "h-8 w-8" : "h-9 w-9 sm:h-10 sm:w-10",
              toneClasses[tone] || toneClasses.default,
            )}
          >
            <Icon className={cn(compact ? "h-4 w-4" : "h-5 w-5")} />
          </div>
        ) : null}
      </div>
    </div>
  );
}

export function StatsGrid({ children, className }) {
  return (
    <div
      className={cn(
        "grid grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-4 xl:grid-cols-4",
        className,
      )}
    >
      {children}
    </div>
  );
}

export default MetricCard;
